interface IsetCTAtext {
  leadFormType: string;
  buttonText: string;
  ctaTextList: any;
}

export const setCTAtext = ({ leadFormType, buttonText, ctaTextList }: IsetCTAtext) => {
  if (buttonText) {
    return buttonText
  } else if (ctaTextList && ctaTextList.length > 0) {
    let ctaText = [];

    switch (leadFormType) {
      case 'health':
      case 'health_email':
      case 'health_en':
      case 'health_fullname':
      case 'health_v2':
        ctaText = ctaTextList.filter((ctaText) => ctaText.category === 'health');
        break;
      case 'micro-rawat-inap':
      case 'micro':
        ctaText = ctaTextList.filter((ctaText) => ctaText.category === 'micro-rawat-inap');
        break;
      case 'auto':
      case 'car':
      case 'car_ext':
      case 'auto_ext':
        ctaText = ctaTextList.filter((ctaText) => ctaText.category === 'auto');
        break;
      case 'moto':
      case 'motorcycle':
        ctaText = ctaTextList.filter((ctaText) => ctaText.category === 'moto');
        break;
      case 'syariah':
      case 'sharia':
        ctaText = ctaTextList.filter((ctaText) => ctaText.category === 'syariah');
        break;
      case 'travel':
        ctaText = ctaTextList.filter((ctaText) => ctaText.category === 'travel');
        break;
    }

    return ctaText[0].text;
  } else {
    return 'Lihat Pilihan Polis';
  }
};
